import { AxiosResponse, Method } from 'axios';
import { globalStore } from 'reduxStore';
import { SessionService } from 'services/SessionService';
import { createBookJaneRequest } from 'utils/createBookJaneRequest';
import {
  isDataLockError,
  reportsDataHealthStore,
} from 'pages/ReportsPage/store/reportsDataHealth.store';
import { DataDashboardTierEnum } from 'types/graphql';

const DASHBOARD_ACCESS_DENIED_STATUS = 403;

export interface ICreateDashboardsRequestOptions {
  url: string;
  method: Method;
  query?: Record<string, unknown>;
  responseType?: 'blob';
  onDownloadProgress?: (progressEvent: ProgressEvent) => void;
}

const getResponseStatus = (error: unknown): number | undefined =>
  (error as { response?: { status?: number } })?.response?.status;

const markDashboardTierAsNone = (): void => {
  SessionService.updateDataDashboardTier(DataDashboardTierEnum.none);
  globalStore.dispatch({
    type: 'auth/updateUserDataDashboardTier',
    payload: { data_dashboard_tier: DataDashboardTierEnum.none },
  });
};

export function createDashboardsRequest<TData = unknown>(
  opts: ICreateDashboardsRequestOptions,
): Promise<AxiosResponse<TData>> {
  return createBookJaneRequest<TData>(opts).then(
    (response) => {
      const { isDataLocked, checkDataLockRecovery } = reportsDataHealthStore.getState();
      if (isDataLocked) void checkDataLockRecovery();
      return response;
    },
    (error) => {
      if (getResponseStatus(error) === DASHBOARD_ACCESS_DENIED_STATUS) {
        markDashboardTierAsNone();
      }
      if (isDataLockError(error)) {
        reportsDataHealthStore.getState().markDataLocked();
      }
      throw error;
    },
  );
}
